module.exports = __webpack_public_path__ + "static/media/workingmemory-numbers-2.e99dde53.mp3";